import { Column, Row } from '@/components/SettingsLayout';
import styles from './styles.module.css';
import { Text, Button, Divider, Input } from '@/ui';
import { useTranslation } from 'react-i18next';
import FeatureGroupRestrictions from './FeatureGroupRestrictions';
import ExtensionsRestrictions from './ExtensionsRestrictions';
import { useFormContext } from 'react-hook-form';
import { Plan } from '@/services/Plans/plans.service';
import { FeatureGroup } from '@/services/Features/features.service';
import { Extension } from '@/services/Extensions/extensions.service';
import CheckoutFlowsAccess from './CheckoutFlowsAccess';

type Props = {
  plan?: Plan;
  featureGroup: FeatureGroup[];
  extensions: Extension[];
  isSaving?: boolean;
};

const PlanRestrictions = ({ featureGroup, extensions, isSaving = false }: Props) => {
  const { t } = useTranslation();
  const {
    reset,
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles.singlePlanFormContainer}>
      <Column gapSize='48' fullWidth>
        <Column gapSize='24' fullWidth>
          <Column gapSize='4' fullWidth>
            <Text size='m' weight='light-medium'>
              {t('Accounts.plan_name')}
            </Text>
            <Input
              variant='rowInput'
              placeholder={t('Accounts.plan_name')}
              {...register('name', {
                required: true,
                maxLength: 50,
              })}
              isError={!!errors.name}
              data-testid='plan-name-input'
            />
            {errors.name?.type === 'required' && (
              <Text size='xs' weight='light-medium' color='red'>
                {t('Form.required.name')}
              </Text>
            )}
            {errors.name?.type === 'maxLength' && (
              <Text size='xs' weight='light-medium' color='red'>
                {t('Form.errors.max_length', { length: 50 })}
              </Text>
            )}
          </Column>
          {featureGroup?.map((group) => (
            <FeatureGroupRestrictions key={group._id} featureGroup={group} />
          ))}
          <Divider />
          {extensions && <ExtensionsRestrictions extensions={extensions} />}
          <CheckoutFlowsAccess />
        </Column>
        <Row fullWidth justify='justify-between'>
          <Button
            type='button'
            variant='danger'
            onClick={() => reset()}
            data-testid='reset-to-default-button'
          >
            {t('Shared.reset')}
          </Button>
          <Button
            type='submit'
            variant='primary'
            disabled={isSaving}
            data-testid='update-plan-button'
          >
            {isSaving ? t('Shared.loading') : t('Shared.update')}
          </Button>
        </Row>
      </Column>
    </div>
  );
};

export default PlanRestrictions;
